/**
 *
 * @param {*} checkFn subscriptionCheckFn or permissionCheckFn
 * @param {*} keyOrKeys array of keys or single key
 * @param {*} inspectionMode when using array of keys, 'AND' or 'OR'
 *                          - 'AND' means all keys must be true to be unlocked / accessed
 *                          - 'OR' means at least one key must be true to be unlocked / accessed
 * @param  {...any} args - extra args to be passed to checkFn
 * @returns
 */
export function runInspectionFn(checkFn, keyOrKeys, inspectionMode = 'AND', ...args) {
    // console.log('zz runInspectionFn keys', keyOrKeys)

    // If array is provided
    if (Array.isArray(keyOrKeys)) {
        const keys = keyOrKeys;
        if (!keys.length)
            return true;

        // let value;
        // for (const val of values) {
        //     value = val;
        //     if (val === false)
        //         return val;
        // }
        // console.log('zz runInspectionFn keys', keys, value)
        // return !!value;

        const values = keys.map(key => checkFn(key, ...args)); // possible key value: true, false, null
        const hasFalse = values.some(v => v === false);
        const hasTrue = values.some(v => v === true);
        // if (keys.includes(SubscriptionScopeKey.instruction_contact))
        //     console.log('aaa runInspectionFn', { keys, values, hasFalse, hasTrue, inspectionMode });
        if (inspectionMode === 'AND' && hasFalse)
            return false;

        if (inspectionMode === 'OR' && hasTrue)
            return true;

        return !!values[values.length - 1];
    }

    // If non-array is provided (i.e. const key = keys )
    const key = keyOrKeys;
    return !!checkFn(key, ...args); // possible value: true, false, null
}
